import useAuth from '../useAuth';

const useCurrentUser = function () {
  return useAuth().user;
};

export default useCurrentUser;
